import uuidv4 from 'uuid-random';

const uuid = () => uuidv4();

export default uuid;
